<template>
<div>
    <modal v-show="modalState.delete"
           :container="'modal-container'"
           @close="updateModal('delete', false)">
        <template v-slot:header>
            <h3 class="float-left">Delete Scan</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('delete', false)">
            <span aria-hidden="true">&times;</span>
        </button>
        </template>
        <template v-slot:body>
            <p>Please confirm that you would like to delete this scan.</p>
        </template>
        <template v-slot:footer>
            <div class="footer-actions">
                <button class="btn btn-cancel" @click="updateModal('delete', false)">
                    Cancel
                </button>
                <button class="btn btn-danger" @click="deleteScan()">
                    <i class="fa fa-trash"></i>
                    Delete Scan
                </button>
            </div>
        </template>
    </modal>
    <modal v-show="modalState.cancel"
           :container="'modal-container'"
           @close="updateModal('cancel', false)">
        <template v-slot:header>
            <h3>Cancel Scan</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('cancel', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>Please confirm that you would like to cancel that in-progress
            scan.</p>
        </template>
        <template v-slot:footer>
            <button class="btn btn-danger" @click="cancelScan()">
                Confirm
            </button>
        </template>
    </modal>
</div>
</template>

<script>
/* eslint-disable import/extensions */
import '~/assets/js/global.js';
import Modal from '~/components/shared/templates/modal.vue';

export default {
    name: 'modals-cancel-delete',
    components: { Modal },
    props: {
        scan_id: String,
        modalState: {
            delete: false,
            cancel: false,
            close: false,
        },
    },
    methods: {
        cancelScan() {
            this.updateModal('cancel', false);
            this.$emit('cancelScan', this.scan_id);
        },
        deleteScan() {
            this.updateModal('delete', false);
            this.$emit('deleteScan', this.scan_id);
        },
        updateModal(type, state) {
            this.modalState[type] = state;
            this.$emit('updateModal', {
                key: type,
                state,
            });
        },
        close() {
            this.updateModal('close', false);
        },
    },
};
</script>

<style lang="scss" scoped>
.footer-actions {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
}
.btn {
    &.btn-cancel {
        background-color: transparent;
    }
}

</style>
